"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const styles_1 = require("@mui/material/styles");
const HidePrint = ({ children, className, component = "div" }) => {
    const Component = component;
    return ((0, jsx_runtime_1.jsx)(Component, { css: (0, styles_1.css)({
            "@media print": {
                display: "none"
            }
        }), className: (0, classnames_1.default)(className), "data-testid": "hide-print-root", children: children }));
};
exports.default = HidePrint;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGlkZVByaW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hpZGUtcHJpbnQvSGlkZVByaW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSw0REFBb0M7QUFDcEMsaURBQTJDO0FBUTNDLE1BQU0sU0FBUyxHQUFHLENBQUMsRUFBRSxRQUFRLEVBQUUsU0FBUyxFQUFFLFNBQVMsR0FBRyxLQUFLLEVBQVMsRUFBRSxFQUFFO0lBQ3RFLE1BQU0sU0FBUyxHQUFHLFNBQVMsQ0FBQztJQUU1QixPQUFPLENBQ0wsdUJBQUMsU0FBUyxJQUNSLEdBQUcsRUFBRSxJQUFBLFlBQUcsRUFBQztZQUNQLGNBQWMsRUFBRTtnQkFDZCxPQUFPLEVBQUUsTUFBTTthQUNoQjtTQUNGLENBQUMsRUFDRixTQUFTLEVBQUUsSUFBQSxvQkFBVSxFQUFDLFNBQVMsQ0FBQyxpQkFDcEIsaUJBQWlCLFlBRTVCLFFBQVEsR0FDQyxDQUNiLENBQUM7QUFDSixDQUFDLENBQUM7QUFFRixrQkFBZSxTQUFTLENBQUMifQ==